package kz.dentalcrm.app.screens.patients.detail.mvi

import com.kizitonwose.calendar.core.now
import kotlinx.collections.immutable.PersistentList
import kotlinx.collections.immutable.persistentListOf
import kotlinx.datetime.LocalDate
import kz.dentalcrm.app.core.base.ViewState
import kz.dentalcrm.app.core.ui.ScreenState
import kz.dentalcrm.app.data.network.response_model.AppointmentResponse
import kz.dentalcrm.app.data.network.response_model.PatientData
import kotlin.time.ExperimentalTime


data class PatientDetailState @OptIn(ExperimentalTime::class) constructor(
    val patient: PatientData? = null,
    val birth_day_selected: LocalDate? = LocalDate.now(),
    val screenState: ScreenState = ScreenState.Idle,
    val patientAppointments: PersistentList<AppointmentResponse> = persistentListOf(),
    val isAppointmentsLoading: Boolean = false
) : ViewState